import { Component, OnInit } from '@angular/core';
import { Select } from '@ngxs/store';
import { ModulesSelectors } from '@serviceos-ng/core';
import { Observable } from 'rxjs';

@Component({
  selector: 'serviceos-web-contact-details',
  templateUrl: './contact-details.component.html',
  styleUrls: ['./contact-details.component.scss']
})
export class ContactDetailsComponent implements OnInit {

  @Select(ModulesSelectors.getComponentFromModule('account', 'account_settings_screen.contact_details'))
  public contactDetails$!: Observable<any>;

  constructor() { }

  ngOnInit(): void {
    
  }

}
